import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';
import { ContactsApi, GroupSummary, GroupsApi, PagedContactResponse } from 'src/app/hickory-api';
import { DirectoryGroup } from 'src/app/shared/directory/base/models';
import { ApiError } from 'src/app/shared/model/utility';


export interface GroupDetailsData  {
  groupId?: number;
  summary?: GroupSummary;
  title?: string;
}

@Component({
  selector: 'app-group-details-dialog',
  templateUrl: './group-details-dialog.component.html',
  styleUrls: ['./group-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class GroupDetailsDialogComponent implements OnInit {
  readonly data = inject<GroupDetailsData>(MAT_DIALOG_DATA);
  readonly locale = inject<L10nLocale>(L10N_LOCALE);
  private readonly groupsApi = inject(GroupsApi);
  private readonly contactsApi = inject(ContactsApi);
  private readonly dialog = inject(MatDialog);

  group: DirectoryGroup;

  dialogTitle: string;
  loadError: string = null;
  hideRetry: boolean = false;
  contacts: PagedContactResponse;

  ngOnInit(): void {
    this.dialogTitle = this.data.title ?? this.dialogTitle;
    this.loadGroup();
  }

  loadGroup() {
    const groupId = this.data?.groupId ?? this.data?.summary?.id;
    if (!!this.group || !groupId) return;
    this.loadError = null;
    this.hideRetry = false;
    this.groupsApi.getGroupsByIdV21(groupId).subscribe({
      next: (res) => {
        if (res?.item) {
          this.group = DirectoryGroup.fromHickoryFull(res?.item, false);
          if (this.group.children) {
            this.loadContacts();
          }
        } else {
          this.onDetailsNotFound();
        }
      },
      error: (err: ApiError) => {
        this.loadError = 'An error occurred retrieving group details';
        if (err.status === 404) {
          this.onDetailsNotFound();
        } 
      }
    });
  }

  private onDetailsNotFound() {
    this.loadError = 'No details found for this group';
    this.hideRetry = true;
  }

  loadContacts() {
    const groupId = this.data?.groupId ?? this.data?.summary?.id;
    if (!groupId) return;
    this.contactsApi.findContacts({ groupId: groupId, includeNestedGroups: true, includeAsset: false, page: 1, pageSize: 1 }).subscribe({
      next: (res) => {
        this.contacts = res;
      },
      error: (_err) => { }
    });
  }

  closeDialogs() {
    this.dialog.closeAll();
  }
}
